import React, { useState } from 'react'
import { Button, Card, Col, Row } from 'react-bootstrap'
import ImageViewer from '../../common/ImageViewer';
import VideoPlayerModal from '../../common/VideoPlayerModal';

const VRGameDevelopment = () => {
    const [modalShow, setModalShow] = useState(false);
    const [imageUrl, setImageUrl] = useState(null)
    const [videoUrl, setVideoUrl] = useState(null)
    const [chooseModal, setChooseModal] = useState(null)

    const imageDiv = []

    const openVideoModal = (data) => {
        setModalShow(true)
        setChooseModal('video')
        setVideoUrl(data)

    }

    const openImageModal = (data) => {
        setModalShow(true)
        setChooseModal('image')
        setImageUrl(data)
    }

    for (let index = 0; index < 20; index++) {

        imageDiv.push(
            <Col xs={{span:6, offset:0}} md={{span:3, offset:0}} className="no-padding-x" key={index}>
                <Card.Img onClick={() => openImageModal(index)} className='img img-thumbnail game-images' src={"/assets/vr-development/game-development/shelter-in-place-vr/images/"+index+".jpg"} />
            </Col>
        )        
    }


  return (
    <>
        <Card className='text-center no-border rounded-0 industrial-modeling-top-section container'>

            <Card.Body>
                <Card.Title className='industrial-modeling-title'> VRゲーム開発 </Card.Title>
            </Card.Body>
            <Row className='pt-md-5 px-md-5'>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:0}} className="pt-md-5 mt-md-2">
                    <Card.Title className='vr-healthcare-title'> シェルターインプレイス (Shelter in Place) </Card.Title>
                    <Card.Text className='text-left vr-healthcare-text text-left'>
                    当社は、コンシューマー向けVRゲームを2019年11月に「Unnamed VR」として販売開始しましたが、パンデミック発生時にはは「Shelter in Place（シェルターインプレイス）」と改名して無料ダウンロードのVRゲームとして提供しました。 
                    </Card.Text>

                    <Card.Text className='text-left vr-healthcare-text py-md-4 py-3'>
                    <Button className='yellow-schedule-button shelterinplacevr-button btn btn-warning'><a href="https://shelterinplacevr.com" target="_blank" rel="noreferrer"> 詳しく（英語）</a></Button>
                    </Card.Text>
                    
                    
                </Col>
                <Col xs={{span:12, offset:0}} md={{span:6, offset:0}}>
                    <Card className='no-border rounded-0 container healthcare-video-container product-video-section' onClick={() => openVideoModal('/assets/vr-development/game-development/shelter-in-place-vr/video/ShelterPlaceTrailer.mp4')}>
                    <Card.Img className='img img-thumbnail shelterinplacevr-image' src={"/assets/vr-development/game-development/shelter-in-place-vr/images/spvr_001.jpg"} />
                            <Card.ImgOverlay className='playicon-overlay-center'>
                                <Card.Img src={"/assets/icons/video-player.png"} />
                            </Card.ImgOverlay>

                        </Card>
                </Col>
            </Row>
            <Card.Title className='vr-healthcare-title text-center pt-md-5'> シェルターインプレイス (Shelter in Place) </Card.Title>
            <Card.Text className='industrial-environment-text text-left'>
            私たちの最初のコンシューマー向けVRゲームは、VRで探索し楽しむことだけを目的としたオープンエンドのサンドボックスゲームでした。舞台は16の部屋からなる大きな邸宅。通常の部屋では、ほとんどのオブジェクトがインタラクティブなので、どんな小さなオブジェクトでも拾ったり、ジャグリングしたり、投げたり、置いたりすることができます。花瓶は割れ、ボールは弾み、引き出しや食器棚は開くことができます。テレビのリモコンやDVDプレーヤーも使えます。 
            ミニゲームの部屋にはジップラインや 巨大トランポリン、クライミングウォールなどがあるアドベンチャールームや ギター、ドラム、木琴、シンセサイザーなどがあるミュージックルームがあり、 ピンポンルームやバスケットボール、ダーツ、投げ縄、昔のストックヤードにある アーチェリーなど、たくさんの種類のミニゲームが用意されています。 
            レーザー銃やロケットランチャーがあるシューティング・ギャラリー、入るたびに新しいパターンに変わる迷路、スプレーで落書きする部屋、パレットで色を混ぜられる3Dペイントの部屋、積み木の自販機があるおもちゃ部屋など盛りだくさんの内容です。 
            Oculus RiftとHTC Viveのクロスプラットフォームゲームとして作られたShelter in Place（シェルターインプレイス）は、私たちにとってVRであらゆるタイプの物理的インタラクションを作る方法、そしてあらゆるトレーニングや没入型インタラクティブシナリオを作成する能力のベースとなりました。 
            </Card.Text>

            <Row className='py-md-3 px-md-4'>
                {imageDiv}
            </Row>

        </Card>

           
        {chooseModal === "video" && 
             <VideoPlayerModal
                show={modalShow}
                onHide={() => setModalShow(false)}
                videosrc={videoUrl}
           />
        }

        {chooseModal === 'image' &&
            <ImageViewer 
                show={modalShow}
                onHide={() => setModalShow(false)}
                imagesrc={imageUrl}
                imagedir="assets/vr-development/game-development/shelter-in-place-vr/images/enlarge/"
                imagecounter={19}
                mimetype='jpg'
            />
        }

           

    </>
  )
}

export default VRGameDevelopment
